import Vue from 'vue'
import Router from 'vue-router'
import AuthLayout from '../components/auth/AuthLayout'
import AppLayout from '../components/admin/AppLayout'

Vue.use(Router)

const EmptyParentComponent = {
  template: '<router-view></router-view>',
}

const demoRoutes = []

export default new Router({
  mode: process.env.VUE_APP_ROUTER_MODE_HISTORY === 'true' ? 'history' : 'hash',
  routes: [
    ...demoRoutes,
    {
      path: '*',
      redirect: { name: 'dashboard' },
    },
    {
      path: '/auth',
      component: AuthLayout,
      children: [
        {
          name: 'login',
          path: 'login',
          component: () => import('../components/auth/login/Login.vue'),
        },
        {
          name: 'signup',
          path: 'signup',
          component: () => import('../components/auth/signup/Signup.vue'),
        },
        {
          path: '',
          redirect: { name: 'login' },
        },
      ],
    },
    {
      name: 'Admin',
      path: '/admin',
      component: AppLayout,
      children: [
        {
          name: 'dashboard',
          path: 'dashboard',
          component: () => import('../components/dashboard/Dashboard.vue'),
          default: true,
        },
        {
          name: 'referrals',
          path: 'referrals',
          component: EmptyParentComponent,
          children: [
            {
              name: 'listReferral',
              path: 'listReferral',
              component: () => import('../components/referral/referral'),
            },
            {
              name: 'saveReferral',
              path: 'saveReferral',
              component: () => import('../components/referral/saveReferral'),
            },
            {
              name: 'updateReferral',
              path: 'updateReferral/:id',
              component: () => import('../components/referral/saveReferral'),
            },
            {
              name: 'listCareerMonitor',
              path: 'listCareerMonitor',
              component: () => import('../components/referral/careerMonitor'),
            },
            {
              name: 'saveCareerMonitor',
              path: 'saveCareerMonitor',
              component: () => import('../components/referral/saveCareerMonitor'),
            },
            {
              name: 'updateCareerMonitor',
              path: 'updateCareerMonitor/:id',
              component: () => import('../components/referral/saveCareerMonitor'),
            },
            {
              name: 'uploadCareerExcel',
              path: '/uploadCareerExcel',
              component: () => import('../components/referral/uploadCareerExcel'),
            },
            {
              name: 'listDataSource',
              path: 'listDataSource',
              component: () => import('../components/referral/dataSourceList'),
            },
            {
              name: 'dataSourceDetail',
              path: 'dataSourceDetail/:id',
              component: () => import('../components/referral/dataSourceDetail'),
            },
          ],
        },
        {
          name: 'services',
          path: 'services',
          component: EmptyParentComponent,
          children: [
            // 篱笆预告
            {
              name: 'listLibaPreview',
              path: 'listLibaPreview',
              component: () => import('../components/service/libaPreview/listLibaPreview'),
            },
            {
              name: 'saveLibaPreview',
              path: 'saveLibaPreview',
              component: () => import('../components/service/libaPreview/saveLibaPreview'),
            },
            {
              name: 'updateLibaPreview',
              path: 'updateLibaPreview/:id',
              component: () => import('../components/service/libaPreview/saveLibaPreview'),
            },
            // 在线实战项目
            {
              name: 'listOnlineAction',
              path: 'listOnlineAction',
              component: () => import('../components/service/onlineAction/listOnlineAction'),
            },
            {
              name: 'saveOnlineAction',
              path: 'saveOnlineAction',
              component: () => import('../components/service/onlineAction/saveOnlineAction'),
            },
            {
              name: 'updateOnlineAction',
              path: 'updateOnlineAction/:id',
              component: () => import('../components/service/onlineAction/saveOnlineAction'),
            },
            // 免费公开课
            {
              name: 'listFreeOpenCourse',
              path: 'listFreeOpenCourse',
              component: () => import('../components/service/freeOpenCourse/listFreeOpenCourse'),
            },
            {
              name: 'saveFreeOpenCourse',
              path: 'saveFreeOpenCourse',
              component: () => import('../components/service/freeOpenCourse/saveFreeOpenCourse'),
            },
            {
              name: 'updateFreeOpenCourse',
              path: 'updateFreeOpenCourse/:id',
              component: () => import('../components/service/freeOpenCourse/saveFreeOpenCourse'),
            },
            // 名企一对一
            {
              name: 'listEnterpriseToOne',
              path: 'listEnterpriseToOne',
              component: () => import('../components/service/enterpriseToOne/listEnterpriseToOne'),
            },
            {
              name: 'saveEnterpriseToOne',
              path: 'saveEnterpriseToOne',
              component: () => import('../components/service/enterpriseToOne/saveEnterpriseToOne'),
            },
            {
              name: 'updateEnterpriseToOne',
              path: 'updateEnterpriseToOne/:id',
              component: () => import('../components/service/enterpriseToOne/saveEnterpriseToOne'),
            },
            // 求职辅导
            {
              name: 'listJobCounseling',
              path: 'listJobCounseling',
              component: () => import('../components/service/jobCounseling/listJobCounseling'),
            },
            {
              name: 'saveJobCounseling',
              path: 'saveJobCounseling',
              component: () => import('../components/service/jobCounseling/saveJobCounseling'),
            },
            {
              name: 'updateJobCounseling',
              path: 'updateJobCounseling/:id',
              component: () => import('../components/service/jobCounseling/saveJobCounseling'),
            },
            // 讲座。分享会
            {
              name: 'listLecture',
              path: 'listLecture',
              component: () => import('../components/service/lecture/listLecture'),
            },
            {
              name: 'saveLecture',
              path: 'saveLecture',
              component: () => import('../components/service/lecture/saveLecture'),
            },
            {
              name: 'updateLecture',
              path: 'updateLecture/:id',
              component: () => import('../components/service/lecture/saveLecture'),
            },
            {
              name: 'listAllCourse',
              path: 'listAllCourse',
              component: () => import('../components/service/allCourse/listAllCourse'),
            },
          ],
        },
        {
          name: 'consultings',
          path: 'consultings',
          component: EmptyParentComponent,
          children: [
            {
              name: 'listConsulting',
              path: 'listConsulting',
              component: () => import('../components/mentor/listConsulting'),
            },
            {
              name: 'saveConsulting',
              path: 'saveConsulting',
              component: () => import('../components/mentor/saveConsulting'),
            },
            {
              name: 'updateConsulting',
              path: 'updateConsulting/:uid',
              component: () => import('../components/mentor/saveConsulting'),
            },
          ],
        },
        {
          name: 'tags',
          path: 'tags',
          component: EmptyParentComponent,
          children: [
            {
              name: 'listTag',
              path: 'listTag',
              component: () => import('../components/tags/listTag'),
            },
            {
              name: 'saveTag',
              path: 'saveTag',
              component: () => import('../components/tags/saveTag'),
            },
            {
              name: 'updateTag',
              path: 'updateTag/:id',
              component: () => import('../components/tags/saveTag'),
            },
          ],
        },
        {
          name: 'blogs',
          path: 'blogs',
          component: EmptyParentComponent,
          children: [
            {
              name: 'listBlog',
              path: 'listBlog',
              component: () => import('../components/blog/listBlog'),
            },
            {
              name: 'saveBlog',
              path: 'saveBlog',
              component: () => import('../components/blog/saveBlog'),
            },
            {
              name: 'updateBlog',
              path: 'updateBlog/:id',
              component: () => import('../components/blog/saveBlog'),
            },
          ],
        },
        {
          name: 'mentors',
          path: 'mentors',
          component: EmptyParentComponent,
          children: [
            {
              name: 'listMentor',
              path: 'listMentor',
              component: () => import('../components/mentor/listMentor'),
            },
            {
              name: 'saveMentor',
              path: 'saveMentor',
              component: () => import('../components/mentor/getMentor'),
            },
            {
              name: 'getMentor',
              path: 'getMentor/:uid',
              component: () => import('../components/mentor/getMentor'),
            },
            {
              name: 'listOfferedCourse',
              path: 'listOfferedCourse',
              component: () => import('../components/mentor/listOfferedCourse'),
            },
            {
              name: 'listMentorApplication',
              path: 'listMentorApplication',
              component: () => import('../components/mentor/listMentorApplication'),
            },
            {
              name: 'getMentorApplication',
              path: 'getMentorApplication/:uid',
              component: () => import('../components/mentor/getMentorApplication'),
            },
          ],
        },
        {
          name: 'comments',
          path: 'comments',
          component: EmptyParentComponent,
          children: [
            {
              name: 'listComment',
              path: 'listComment',
              component: () => import('../components/mentor/listComment'),
            },
            {
              name: 'saveComment',
              path: 'saveComment',
              component: () => import('../components/mentor/saveComment'),
            },
            {
              name: 'updateComment',
              path: 'updateComment/:commentId',
              component: () => import('../components/mentor/saveComment'),
            },
          ],
        },
        {
          name: 'applications',
          path: 'applications',
          component: EmptyParentComponent,
          children: [
            {
              name: 'listAppliedJob',
              path: 'listAppliedJob',
              component: () => import('../components/application/appliedJob/listAppliedJob'),
            },
            {
              name: 'getAppliedJob',
              path: 'getAppliedJob/:id',
              component: () => import('../components/application/appliedJob/getAppliedJob'),
            }, {
              name: 'listAppliedCourse',
              path: 'listAppliedCourse',
              component: () => import('../components/application/appliedCourse/listAppliedCourse'),
            },
            {
              name: 'getAppliedCourse',
              path: 'getAppliedCourse/:id',
              component: () => import('../components/application/appliedCourse/getAppliedCourse'),
            },
            {
              name: 'listAppliedConsulting',
              path: 'listAppliedConsulting',
              component: () => import('../components/application/appliedConsulting/listAppliedConsulting'),
            },
            {
              name: 'getAppliedConsulting',
              path: 'getAppliedConsulting/:id',
              component: () => import('../components/application/appliedConsulting/getAppliedConsulting'),
            },
          ],
        },
        {
          name: 'users',
          path: 'users',
          component: EmptyParentComponent,
          children: [
            {
              name: 'listUser',
              path: 'listUser',
              component: () => import('../components/user/listUser'),
            },
            {
              name: 'updateUser',
              path: 'updateUser/:uid',
              component: () => import('../components/user/saveUser'),
            },
            {
              name: 'listLoginInfo',
              path: 'listLoginInfo',
              component: () => import('../components/user/listLoginInfo'),
            },
          ],
        },
        {
          name: 'virtualMoney',
          path: 'virtualMoney',
          component: EmptyParentComponent,
          children: [
            {
              name: 'listVirtualMoneyRecord',
              path: 'listVirtualMoneyRecord',
              component: () => import('../components/virtualMoney/listVirtualMoneyRecord'),
            },
            {
              name: 'getVirtualMoneyRecord',
              path: 'getVirtualMoneyRecord/:recordId',
              component: () => import('../components/virtualMoney/getVirtualMoneyRecord'),
            },
          ],
        },
        {
          name: 'auditings',
          path: 'auditings',
          component: EmptyParentComponent,
          children: [
            {
              name: 'listAuditingConsulting',
              path: 'listAuditingConsulting',
              component: () => import('../components/mentor/auditings/listAuditingConsulting'),
            },
            {
              name: 'getAuditingConsulting',
              path: 'getAuditingConsulting/:uid',
              component: () => import('../components/mentor/auditings/getAuditingConsulting'),
            },
            {
              name: 'listAuditingCourse',
              path: 'listAuditingCourse',
              component: () => import('../components/mentor/auditings/listAuditingCourse'),
            },
            {
              name: 'getAuditingEnterpriseToOne',
              path: 'getAuditingEnterpriseToOne',
              component: () => import('../components/mentor/auditings/getAuditingEnterpriseToOne'),
            },
            {
              name: 'getAuditingOnlineAction',
              path: 'getAuditingOnlineAction',
              component: () => import('../components/mentor/auditings/getAuditingOnlineAction'),
            },
            {
              name: 'getAuditingJobCounseling',
              path: 'getAuditingJobCounseling',
              component: () => import('../components/mentor/auditings/getAuditingJobCounseling'),
            },
          ],
        },
        {
          name: 'group',
          path: 'group',
          component: EmptyParentComponent,
          children: [
            {
              name: 'listGroup',
              path: 'listGroup',
              component: () => import('../components/group/listGroup'),
            },
            {
              name: 'listPrivateGroup',
              path: 'listPrivateGroup',
              component: () => import('../components/group/listPrivateGroup'),
            },
            {
              name: 'saveGroup',
              path: 'saveGroup/:id',
              component: () => import('../components/group/saveGroup'),
            },
            {
              name: 'listChannel',
              path: ':groupId/listChannel',
              component: () => import('../components/group/listChannel'),
            },
            {
              name: 'saveChannel',
              path: ':groupId/saveChannel',
              component: () => import('../components/group/saveChannel'),
            },
            {
              name: 'updateChannel',
              path: ':groupId/saveChannel/:id',
              component: () => import('../components/group/saveChannel'),
            },
            {
              name: 'listChannelMember',
              path: 'channel/:channelId/members',
              component: () => import('../components/group/listChannelMember'),
            },
            {
              name: 'listGroupMember',
              path: ':groupId/members',
              component: () => import('../components/group/listGroupMember'),
            },
            {
              name: 'chat',
              path: 'channel/:channelId/chat',
              component: () => import('../components/group/channelMessage'),
            },
            {
              name: 'listC2cGroup',
              path: 'listC2cGroup',
              component: () => import('../components/group/listC2cGroup'),
            },
            {
              name: 'privateMessage',
              path: ':chatId/privateMessage',
              component: () => import('../components/group/privateMessage'),
            },
          ],
        },
        {
          name: 'video',
          path: 'video',
          component: EmptyParentComponent,
          children: [
            {
              name: 'saveVideo',
              path: 'saveVideo',
              component: () => import('../components/video/saveVideo'),
            },
            {
              name: 'updateVideo',
              path: 'updateVideo/:videoId',
              component: () => import('../components/video/saveVideo'),
            },
          ],
        },
        {
          name: 'employee',
          path: 'employee',
          component: EmptyParentComponent,
          children: [
            {
              name: 'listEmployee',
              path: 'listEmployee',
              component: () => import('../components/employee/listEmployee'),
            },
            {
              name: 'updateEmployee',
              path: 'updateEmployee/:id',
              component: () => import('../components/employee/saveEmployee'),
            },
            {
              name: 'resetPassword',
              path: 'resetPassword',
              component: () => import('../components/employee/resetPassword'),
            },
          ],
        },
        {
          name: 'permission',
          path: 'permission',
          component: EmptyParentComponent,
          children: [
            {
              name: 'listRole',
              path: 'listRole',
              component: () => import('../components/permission/listRole'),
            },
            {
              name: 'saveRole',
              path: 'saveRole',
              component: () => import('../components/permission/saveRole'),
            },
            {
              name: 'updateRole',
              path: 'updateRole/:id',
              component: () => import('../components/permission/saveRole'),
            },
            {
              name: 'listBusiness',
              path: 'listBusiness',
              component: () => import('../components/permission/listBusiness'),
            },
            {
              name: 'saveBusiness',
              path: 'saveBusiness',
              component: () => import('../components/permission/saveBusiness'),
            },
            {
              name: 'updateBusiness',
              path: 'updateBusiness/:id',
              component: () => import('../components/permission/saveBusiness'),
            },
            {
              name: 'listPermission',
              path: 'listPermission',
              component: () => import('../components/permission/listPermission'),
            },
            {
              name: 'savePermission',
              path: 'savePermission',
              component: () => import('../components/permission/savePermission'),
            },
          ],
        },
        {
          name: 'interviewQuestions',
          path: 'interviewQuestions',
          component: EmptyParentComponent,
          children: [
            {
              name: 'listInterviewQuestion',
              path: '/listInterviewQuestion',
              component: () => import('../components/interviewQuestions/listInterviewQuestion'),
            },
            {
              name: 'saveInterviewQuestion',
              path: '/saveInterviewQuestion',
              component: () => import('../components/interviewQuestions/saveInterviewQuestion'),
            },
            {
              name: 'updateInterviewQuestion',
              path: '/updateInterviewQuestion/:id',
              component: () => import('../components/interviewQuestions/saveInterviewQuestion'),
            },
            {
              name: 'listPracticeQuestion',
              path: '/listPracticeQuestion',
              component: () => import('../components/interviewQuestions/listPracticeQuestion'),
            },
            {
              name: 'savePracticeQuestion',
              path: '/savePracticeQuestion',
              component: () => import('../components/interviewQuestions/savePracticeQuestion'),
            },
            {
              name: 'updatePracticeQuestion',
              path: '/updatePracticeQuestion/:id',
              component: () => import('../components/interviewQuestions/savePracticeQuestion'),
            },
            {
              name: 'listOrganization',
              path: 'listOrganization',
              component: () => import('../components/interviewQuestions/listOrganization'),
            },
            {
              name: 'saveOrganization',
              path: 'saveOrganization',
              component: () => import('../components/interviewQuestions/saveOrganization'),
            },
            {
              name: 'updateOrganization',
              path: 'updateOrganization/:id',
              component: () => import('../components/interviewQuestions/saveOrganization'),
            },
            {
              name: 'listPositionTag',
              path: 'listPositionTag',
              component: () => import('../components/interviewQuestions/listPositionTag'),
            },
            {
              name: 'savePositionTag',
              path: 'savePositionTag',
              component: () => import('../components/interviewQuestions/savePositionTag'),
            },
            {
              name: 'updatePositionTag',
              path: 'updatePositionTag/:id',
              component: () => import('../components/interviewQuestions/savePositionTag'),
            },
            {
              name: 'listQuestionTag',
              path: ':positionTagId/listQuestionTag',
              component: () => import('../components/interviewQuestions/listQuestionTag'),
            },
            {
              name: 'saveQuestionTag',
              path: ':positionTagId/saveQuestionTag',
              component: () => import('../components/interviewQuestions/saveQuestionTag'),
            },
            {
              name: 'updateQuestionTag',
              path: ':positionTagId/updateQuestionTag/:id',
              component: () => import('../components/interviewQuestions/saveQuestionTag'),
            },
            {
              name: 'listPost',
              path: '/listPost',
              component: () => import('../components/interviewQuestions/listPost'),
            },
            {
              name: 'savePost',
              path: '/savePost',
              component: () => import('../components/interviewQuestions/savePost'),
            },
            {
              name: 'updatePost',
              path: '/updatePost/:postId',
              component: () => import('../components/interviewQuestions/savePost'),
            },
            {
              name: 'uploadExcel',
              path: '/uploadExcel',
              component: () => import('../components/interviewQuestions/uploadExcel'),
            },
            {
              name: 'uploadPdf',
              path: '/uploadPdf',
              component: () => import('../components/interviewQuestions/uploadPdf'),
            },
          ],
        },
        {
          name: 'openJob',
          path: 'openJob',
          component: EmptyParentComponent,
          children: [
            {
              name: 'listJobUser',
              path: 'listJobUser',
              component: () => import('../components/openJob/listUser'),
            },
            {
              name: 'interviewInbox',
              path: 'interviewInbox',
              component: () => import('../components/openJob/interviewInbox'),
            },
            {
              name: 'autoApplySuccessRate',
              path: 'autoApplySuccessRate',
              component: () => import('../components/openJob/autoApplySuccessRate'),
            },
            {
              name: 'getJobUser',
              path: 'getJobUser/:uid',
              component: () => import('../components/openJob/getUser'),
            },
            {
              name: 'pushDeliverStats',
              path: 'pushDeliverStats',
              component: () => import('../components/openJob/pushDeliverStats'),
            },
            {
              name: 'pushDeliverStatsDetail',
              path: 'pushDeliverStats/:uid',
              component: () => import('../components/openJob/pushDeliverStatsDetail'),
            },
          ],
        },
      ],
    },
  ],
})
